export default class CenterOfHopeSummaryDto {
  constructor(options = {}) {
    this.barrierCount = options.barrierCount || [];
    this.goalCount = options.goalCount || [];
    this.barrierProgressCount = options.barrierProgressCount || [];
    this.goalProgressCount = options.goalProgressCount || [];
    this.barrierText = options.barrierText || [];
    this.goalText = options.goalText || [];

    this.barrierCircleChartData = options.barrierCircleChartData || { labels: [], values: [], total: 0 };
    this.goalCircleChartData = options.goalCircleChartData || { labels: [], values: [], total: 0 };
    this.barrierStackedBarChartData = options.barrierStackedBarChartData || { categories: [], series: [] };
    this.goalStackedBarChartData = options.goalStackedBarChartData || { categories: [], series: [] };
  }

  stringify() {
    return JSON.stringify(this);
  }
}
